(function () {
  if (!window.CfonElements) return;

  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function uniqueId(base, used) {
    let id = base || 'section';
    let n = 2;
    while (used.has(id) || document.getElementById(id)) {
      id = `${base || 'section'}-${n}`;
      n += 1;
    }
    used.add(id);
    return id;
  }

  function headingLevel(el) {
    const match = /^H([1-6])$/.exec(el.tagName);
    return match ? Number(match[1]) : null;
  }

  class CfonArticleToc extends CfonElements.Component {
    onConnect() {
      this.maxDepth = this.numAttr('maxDepth', 2);
      this.build();
    }

    onDisconnect() {
      this.innerHTML = '';
    }

    build() {
      const content = document.querySelector('[data-article-content]');
      if (!content) {
        this.dataset.empty = 'true';
        this.innerHTML = '';
        return;
      }

      const usedIds = new Set();
      const nodes = [];
      const children = Array.from(content.children);
      const listHandled = new WeakSet();

      children.forEach((el, index) => {
        const level = headingLevel(el);
        if (level) {
          const label = (el.textContent || '').trim();
          if (!label) return;
          const id = uniqueId(slugify(label), usedIds);
          el.id = id;
          nodes.push({ type: 'heading', level, label, id });
          return;
        }

        if (el.tagName === 'P') {
          const next = children[index + 1];
          if (next && (next.tagName === 'UL' || next.tagName === 'OL')) {
            const label = (el.textContent || '').trim();
            if (label) {
              const id = uniqueId(slugify(label), usedIds);
              el.id = id;
              nodes.push({ type: 'list-intro', level: 2, label, id });
            }
            listHandled.add(next);
            Array.from(next.children).forEach((li) => {
              if (li.tagName !== 'LI') return;
              const strong = li.querySelector(':scope > strong, :scope > p > strong');
              if (!strong) return;
              const itemLabel = (strong.textContent || '').trim();
              if (!itemLabel) return;
              const id = uniqueId(slugify(itemLabel), usedIds);
              if (!li.id) li.id = id;
              strong.id = id;
              nodes.push({ type: 'list-item', level: 3, label: itemLabel, id });
            });
          }
          return;
        }

        if (el.tagName === 'UL' || el.tagName === 'OL') {
          if (listHandled.has(el)) return;
          Array.from(el.children).forEach((li) => {
            if (li.tagName !== 'LI') return;
            const strong = li.querySelector(':scope > strong, :scope > p > strong');
            if (!strong) return;
            const label = (strong.textContent || '').trim();
            if (!label) return;
            const id = uniqueId(slugify(label), usedIds);
            if (!li.id) li.id = id;
            strong.id = id;
            nodes.push({ type: 'list-item', level: 3, label, id });
          });
        }
      });

      if (!nodes.length) {
        this.dataset.empty = 'true';
        this.innerHTML = '';
        return;
      }

      const minLevel = nodes.reduce((min, node) => Math.min(min, node.level), 6);
      const pruned = nodes
        .map((node) => ({ ...node, depth: node.level - minLevel + 1 }))
        .filter((node) => node.depth <= this.maxDepth);

      if (!pruned.length) {
        this.dataset.empty = 'true';
        this.innerHTML = '';
        return;
      }

      const root = document.createElement('ul');
      root.className = 'cfon-article-toc__list';
      const stack = [{ depth: 0, list: root }];

      pruned.forEach((node) => {
        while (stack.length > 1 && stack[stack.length - 1].depth >= node.depth) {
          stack.pop();
        }
        while (stack[stack.length - 1].depth < node.depth - 1) {
          const wrapItem = document.createElement('li');
          wrapItem.className = 'cfon-article-toc__item';
          const wrapList = document.createElement('ul');
          wrapList.className = 'cfon-article-toc__list';
          wrapItem.appendChild(wrapList);
          stack[stack.length - 1].list.appendChild(wrapItem);
          stack.push({ depth: stack[stack.length - 1].depth + 1, list: wrapList });
        }

        const item = document.createElement('li');
        item.className = 'cfon-article-toc__item';
        const link = document.createElement('a');
        link.className = 'cfon-article-toc__link';
        link.href = `#${node.id}`;
        link.textContent = node.label;
        link.addEventListener('click', (event) => this.onNavClick(event, node.id));
        item.appendChild(link);

        const childList = document.createElement('ul');
        childList.className = 'cfon-article-toc__list';
        item.appendChild(childList);
        stack[stack.length - 1].list.appendChild(item);
        stack.push({ depth: node.depth, list: childList });
      });

      root.querySelectorAll('.cfon-article-toc__list').forEach((list) => {
        if (!list.children.length) list.remove();
      });

      this.innerHTML = '';
      this.appendChild(root);
      this.dataset.empty = 'false';
    }

    onNavClick(event, id) {
      event.preventDefault();
      const target = document.getElementById(id);
      if (!target) return;
      const headerHeight = Number.parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--cfon-header-height')
      );
      const offset = Number.isFinite(headerHeight) ? headerHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      const reduced =
        (window.CfonElements && typeof window.CfonElements.prefersReducedMotion === 'function'
          ? window.CfonElements.prefersReducedMotion()
          : false) || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: reduced ? 'auto' : 'smooth',
      });
      history.replaceState(null, '', `#${id}`);
    }
  }

  class CfonArticleShare extends CfonElements.Component {
    onConnect() {
      this.url = this.dataset.url || window.location.href;
      this.copied = this.dataset.copied || 'Link copied';
      this.failed = this.dataset.failed || 'Could not copy link';
      this.statusEl = this.querySelector('[data-status]');
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    onDisconnect() {
      this.removeEventListener('click', this.onClick);
    }

    async onClick(event) {
      const button = event.target.closest('[data-share]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      try {
        if (!navigator.clipboard || !navigator.clipboard.writeText) {
          throw new Error(this.failed);
        }
        await navigator.clipboard.writeText(this.url);
        this.setStatus(this.copied);
      } catch (error) {
        this.setStatus(this.failed);
      }
    }

    setStatus(message) {
      if (!this.statusEl) return;
      this.statusEl.textContent = message;
    }
  }

  class CfonArticleTagFilter extends CfonElements.Component {
    onConnect() {
      this.form = this.querySelector('[data-article-filter-form]');
      this.input = this.querySelector('[data-article-filter-input]');
      if (!this.form || !this.input) return;

      this._filterTimer = null;
      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
      this.input.addEventListener('input', this.onInput);
    }

    onDisconnect() {
      this.clearFilterTimer();
      if (!this.form || !this.input) return;
      this.form.removeEventListener('submit', this.onSubmit);
      this.input.removeEventListener('input', this.onInput);
    }

    clearFilterTimer() {
      if (this._filterTimer == null) return;
      clearTimeout(this._filterTimer);
      this._filterTimer = null;
    }

    onSubmit(event) {
      event.preventDefault();
      this.clearFilterTimer();
      this.applyFilter(this.input.value);
    }

    onInput() {
      this.clearFilterTimer();
      this._filterTimer = setTimeout(() => {
        this._filterTimer = null;
        this.applyFilter(this.input.value);
      }, 300);
    }

    cardItems() {
      return Array.from(document.querySelectorAll('cfon-article-grid [data-list] > .cfon-article-grid__item'));
    }

    applyFilter(rawQuery) {
      const query = String(rawQuery || '')
        .trim()
        .toLowerCase();
      const items = this.cardItems();
      let visible = 0;

      items.forEach((item) => {
        if (!query) {
          item.hidden = false;
          visible += 1;
          return;
        }
        const haystack = (item.textContent || '').toLowerCase();
        const match = haystack.includes(query);
        item.hidden = !match;
        if (match) visible += 1;
      });

      document.querySelectorAll('cfon-article-grid [data-pagination]').forEach((el) => {
        el.hidden = Boolean(query);
      });

      this.dataset.filterActive = query ? 'true' : 'false';
      this.dataset.filterCount = String(visible);
    }
  }

  CfonElements.define('cfon-article-toc', CfonArticleToc);
  CfonElements.define('cfon-article-share', CfonArticleShare);
  CfonElements.define('cfon-article-tag-filter', CfonArticleTagFilter);
})();
